// Service Tracking (reporting/attribution + setup pixel/CAPI + copilot/reco).
import { getRequest, postRequest, patchRequest } from "./api/apiService";

export const ATTRIBUTION_MODELS = [
  { value: "last_click", label: "Dernier clic" },
  { value: "first_click", label: "Premier clic" },
  { value: "linear", label: "Linéaire" },
  { value: "time_decay", label: "Décroissance" },
  { value: "position_based", label: "Position" },
];

export const fetchReport = (params = {}) => getRequest("/api/track/report", params);
export const fetchCohorts = (params = {}) => getRequest("/api/track/cohorts", params);
export const fetchCopilot = (params = {}) => getRequest("/api/track/copilot", params);
export const askCopilot = (question, params = {}) => postRequest(`/api/track/copilot/ask?${new URLSearchParams(params)}`, { question });
export const fetchRecommendations = (params = {}) => getRequest("/api/track/recommendations", params);
export const fetchPaths = (params = {}) => getRequest("/api/track/paths", params);
export const fetchAlerts = (params = {}) => getRequest("/api/track/alerts", params);
export const fetchDiagnostics = () => getRequest("/api/track/diagnostics");
export const buildUrl = (payload) => postRequest("/api/track/url-builder", payload);
export const fetchEvents = (limit = 50) => getRequest("/api/track/events", { limit });
export const fetchSnippet = () => getRequest("/api/track/snippet");
export const fetchCapiStatus = () => getRequest("/api/track/capi-status");

// ── Parcours de configuration (persisté côté serveur, reprise possible) ──
export const SETUP_STEPS = [
  { key: "site", label: "Votre site", hint: "Où installer le suivi" },
  { key: "pixels", label: "Vos pixels", hint: "Un pixel par régie" },
  { key: "events", label: "Vos événements", hint: "Ce que l'on mesure" },
  { key: "verify", label: "Vérification", hint: "Test en conditions réelles" },
];

export const SITE_PLATFORMS = [
  { value: "shopify", label: "Shopify", note: "Webhook commandes + extension Web Pixel" },
  { value: "woocommerce", label: "WooCommerce", note: "Plugin + snippet JS" },
  { value: "custom", label: "Site sur mesure", note: "Snippet JS à coller dans le <head>" },
  { value: "gtm", label: "Google Tag Manager", note: "Balise HTML personnalisée" },
];

export const EVENT_CATALOG = [
  { value: "pageview", label: "Page vue", always: true },
  { value: "viewcontent", label: "Produit consulté" },
  { value: "addtocart", label: "Ajout au panier" },
  { value: "checkout", label: "Commande initiée" },
  { value: "purchase", label: "Achat", critical: true },
  { value: "lead", label: "Lead" },
  { value: "signup", label: "Inscription" },
];

export const fetchSetup = () => getRequest("/api/track/setup");
export const fetchSetupContext = () => getRequest("/api/track/setup/context");
export const saveSetupSite = (payload) => patchRequest("/api/track/setup/site", payload);
export const saveSetupPixel = (payload) => patchRequest("/api/track/setup/pixels", payload);
export const validateSetupPixel = (payload) => postRequest("/api/track/setup/pixels/validate", payload);
export const saveSetupEvents = (enabled) => patchRequest("/api/track/setup/events", { enabled });
export const verifySetup = () => postRequest("/api/track/setup/verify", {});
export const skipSetupStep = (step) => postRequest(`/api/track/setup/step/${step}/skip`, {});
export const resetSetup = () => postRequest("/api/track/setup/reset", {});
